document.addEventListener('DOMContentLoaded', () => {
  const videoButton = document.querySelector('[data-modal-open="video-modal"]');
  const videoModal = document.getElementById('video-modal');
  const iframePlaceholder = document.getElementById('video-iframe-placeholder');
  
  // Horizon theme's modal initialization utility
  const initializeModal = () => {
    if (window.Theme && typeof window.Theme.initModals === 'function') {
      window.Theme.initModals();
    }
  };

  if (videoButton && videoModal) {
    // 1. Convert Vimeo URL to Embed URL
    const vimeoUrl = videoButton.dataset.videoUrl;
    // This regex extracts the video ID from any Vimeo link format
    const vimeoMatch = vimeoUrl.match(/vimeo\.com\/(\d+)/); 
    let embedUrl = '';

    if (vimeoMatch && vimeoMatch[1]) {
      const videoId = vimeoMatch[1];
      // Using /video/ instead of /clip/ and adding necessary parameters
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
    }

    // 2. Set up event listener on button click
    videoButton.addEventListener('click', (event) => {
      event.preventDefault();
      
      // Only insert the iframe if we have a valid URL
      if (embedUrl) {
        // Clear previous content and insert the new iframe
        iframePlaceholder.innerHTML = `
          <iframe src="${embedUrl}"
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          </iframe>
        `;
      }
      
      // The Horizon theme's built-in mechanism will open the modal
      // after the data-modal-open attribute is clicked.
    });

    // 3. Clear the video when the modal closes
    videoModal.addEventListener('modal:closed', () => {
      // Stopping the video by clearing the iframe content
      iframePlaceholder.innerHTML = ''; 
    });
    
    // Initialize the theme's modal handlers
    initializeModal();
  }
});